// src/components/ui/Layout/Divider.tsx
import React from 'react';
import styles from './Divider.module.css';

export interface DividerProps {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
  margin?: 'none' | 'sm' | 'md' | 'lg';
}

export const Divider: React.FC<DividerProps> = ({
  className = '',
  orientation = 'horizontal',
  margin = 'md'
}) => {
  // Получаем основной класс ориентации
  const orientationClass = styles[orientation];
  
  // Получаем класс для отступов в зависимости от ориентации
  const marginClass = orientation === 'horizontal' 
    ? styles[`marginHorizontal${margin.charAt(0).toUpperCase() + margin.slice(1)}`]
    : styles[`marginVertical${margin.charAt(0).toUpperCase() + margin.slice(1)}`];
  
  // Собираем все классы
  const dividerClasses = [
    styles.divider,
    orientationClass,
    marginClass,
    className
  ].filter(Boolean).join(' ');
  
  return (
    <div className={dividerClasses}></div>
  );
};

export default Divider;